import { FILE_LIBRARY_INCLUDED_BYTES, FILE_LIBRARY_WARNING_RATIO } from './types';
import type { FileLibraryUsageDto } from './types';

export const bytesToGiB = (bytes: number): string => `${(bytes / 1024 ** 3).toFixed(2)} GiB`;

export const bytesToHuman = (bytes: number): string => {
  if (bytes >= 1024 ** 3) return bytesToGiB(bytes);
  if (bytes >= 1024 ** 2) return `${(bytes / 1024 ** 2).toFixed(1)} MiB`;
  if (bytes >= 1024) return `${(bytes / 1024).toFixed(1)} KiB`;
  return `${bytes} B`;
};

export const usagePercent = (usage?: FileLibraryUsageDto | null): number => {
  const limit = usage?.effective_limit_bytes || FILE_LIBRARY_INCLUDED_BYTES;
  if (limit <= 0) return 0;
  if (typeof usage?.used_ratio === 'number')
    return Math.min(100, Math.round(usage.used_ratio * 100));
  return Math.min(100, Math.round(((usage?.used_bytes ?? 0) / limit) * 100));
};

export const isUsageWarning = (usage?: FileLibraryUsageDto | null): boolean => {
  if (usage?.state === 'warning' || usage?.state === 'overage') return true;
  const limit = usage?.effective_limit_bytes || FILE_LIBRARY_INCLUDED_BYTES;
  return (usage?.projected_bytes ?? usage?.used_bytes ?? 0) >= limit * FILE_LIBRARY_WARNING_RATIO;
};

export const isUsageOver = (usage?: FileLibraryUsageDto | null): boolean =>
  usage?.state === 'overage' ||
  (usage?.overage_bytes ?? 0) > 0 ||
  (usage?.projected_bytes ?? usage?.used_bytes ?? 0) >
    (usage?.effective_limit_bytes || FILE_LIBRARY_INCLUDED_BYTES);
